/* unplugin-vue-components disabled */import script from "./PasswordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordDialog.vue?vue&type=script&setup=true&lang=js"

import "./PasswordDialog.vue?vue&type=style&index=0&id=159c243a&lang=stylus"

const __exports__ = script;

export default __exports__